import React from 'react';

const AnnSacksLogo = /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "100", height: "27", viewBox: "0 0 100 27", fill: "none" }, /* @__PURE__ */ React.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.34446 26.0693V14.5146H3.44459V26.0693H1.23364V14.4812H0V12.227H1.23364V3.91159C1.23364 1.95797 2.86782 0.355 4.90254 0.355C6.93725 0.355 8.57143 1.94127 8.57143 3.91159V26.0693H6.34446ZM4.8865 2.60917C4.08543 2.60917 3.44457 3.24368 3.44457 4.01176V12.1769H6.34444V4.01176C6.34444 3.24368 5.68756 2.60917 4.8865 2.60917Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.7344 25.9852H62.5827V16.2632H59.7638V25.9852H57.6121V16.2295H56.5112V14.1102H57.6121V8.2568C57.6121 6.42341 59.1967 4.92642 61.1649 4.92642C63.1332 4.92642 64.7178 6.42341 64.7178 8.2568L64.7344 25.9852ZM61.265 7.0794C60.481 7.0794 59.8638 7.66811 59.8638 8.39137V14.0934H62.6828V8.39137C62.6828 7.66811 62.0489 7.0794 61.265 7.0794Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    d: "M18.5474 5.01053V17.4238L15.2447 5.01053H13.1431V25.9684H15.3115V13.2692L18.6308 25.9684H20.7158V5.01053H18.5474Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    d: "M30.4237 5.01053V17.4238L27.1211 5.01053H25.0194V25.9684H27.1878V13.2692L30.4904 25.9684H32.5754V5.01053H30.4237Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    d: "M70.856 15.5063V22.6043C70.856 23.3276 71.4898 23.9163 72.2571 23.9163C73.0411 23.9163 73.6582 23.3276 73.6582 22.6043V18.8198H75.81V22.7389C75.81 24.5723 74.2087 26.0693 72.2571 26.0693C70.2889 26.0693 68.7043 24.5723 68.7043 22.7389V8.27362C68.7043 6.44023 70.2889 4.94325 72.2571 4.94325C74.2254 4.94325 75.81 6.44023 75.81 8.27362V12.2095H73.6749V8.40819C73.6749 7.68492 73.0411 7.09622 72.2738 7.09622C71.4898 7.09622 70.8727 7.68492 70.8727 8.40819L70.856 15.5063Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    d: "M89.5877 9.43421C89.5877 11.0321 90.2382 12.4114 91.5726 14.1775C93.9745 17.3397 94.5583 18.1638 94.5583 20.3505V22.6043C94.5583 23.3276 93.9245 23.9163 93.1572 23.9163C92.3733 23.9163 91.7561 23.3276 91.7561 22.6043V19.8122H89.6044V22.7221C89.6044 24.5555 91.2057 26.0525 93.1572 26.0525C95.1255 26.0525 96.7101 24.5555 96.7101 22.7221V20.3505C96.7101 18.147 96.4265 17.4238 95.2923 15.5735C94.8568 14.8546 94.3273 14.1822 93.8114 13.5271C92.7463 12.1746 91.7394 10.896 91.7394 9.43421V8.39136C91.7394 7.6681 92.3733 7.0794 93.1405 7.0794C93.9245 7.0794 94.5417 7.6681 94.5417 8.39136V9.97245H96.6934V8.2568C96.6934 6.42341 95.1088 4.92642 93.1405 4.92642C91.1723 4.92642 89.5877 6.42341 89.5877 8.2568V9.43421Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.4112 25.9515V24.6227H98.9283C99.0784 24.6227 99.1952 24.6564 99.2619 24.7237C99.3286 24.7909 99.362 24.875 99.362 24.9928C99.362 25.0432 99.3453 25.1105 99.3286 25.1442C99.312 25.1946 99.2953 25.2283 99.2619 25.2619C99.2286 25.2955 99.1952 25.3124 99.1618 25.3292C99.1285 25.346 99.0784 25.3628 99.0284 25.3628L99.4287 25.9515H99.2286L98.8616 25.3628H98.578V25.9515H98.4112ZM98.9452 25.2283C98.9848 25.2283 99.0139 25.2177 99.0492 25.205C99.0584 25.2017 99.0682 25.1981 99.0786 25.1946C99.112 25.1778 99.1453 25.161 99.162 25.1274C99.1787 25.0937 99.1954 25.0433 99.1954 24.9928C99.1954 24.9592 99.1954 24.9087 99.162 24.8751C99.1504 24.8516 99.1306 24.8363 99.1141 24.8235C99.1069 24.818 99.1003 24.8129 99.0953 24.8078C99.0619 24.791 99.0286 24.7741 98.9952 24.7741C98.9785 24.7741 98.9577 24.7699 98.9369 24.7657C98.916 24.7615 98.8951 24.7573 98.8784 24.7573H98.5782V25.2283H98.9452Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.844 26.6407C99.4807 26.6407 100 26.1214 100 25.4847C100 24.8481 99.4807 24.3288 98.844 24.3288C98.2073 24.3288 97.6879 24.8481 97.6879 25.4847C97.6879 26.1214 98.2073 26.6407 98.844 26.6407ZM97.8052 25.4512C97.822 24.8816 98.2744 24.446 98.8441 24.4628C99.3802 24.4795 99.8159 24.9151 99.8326 25.4512C99.8494 26.0041 99.4137 26.4732 98.8441 26.4899H98.7938C98.2241 26.4732 97.7885 26.0208 97.8052 25.4512Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    d: "M49.3148 2.63343C48.3095 2.63343 47.4885 3.38732 47.4885 4.3255L47.455 5.79978C47.455 7.60959 48.6695 9.19028 49.9535 10.8616C50.5713 11.6656 51.2051 12.4906 51.7276 13.3722C53.0681 15.6506 53.4199 16.5386 53.4199 19.2526V22.4859C53.4199 24.5466 51.5601 26.2219 49.2813 26.2219C47.0026 26.2219 45.1427 24.5466 45.1427 22.4859V18.6159H47.455V22.2681C47.455 23.2063 48.276 23.9602 49.2813 23.9602C50.2867 23.9602 51.1077 23.2063 51.1077 22.2681V19.3196C51.1077 16.6391 50.4207 15.6339 47.522 11.7472C45.9135 9.58599 45.1427 7.84366 45.1427 5.88354V4.09096C45.1427 2.03032 47.0026 0.355 49.2981 0.355C51.5936 0.355 53.4534 2.03032 53.4534 4.09096V6.55367H51.1412V4.3255C51.1412 3.40408 50.3202 2.63343 49.3148 2.63343Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    d: "M86.3446 5.28043L84.8533 14.9973C85.7414 15.6004 86.3278 16.5721 86.3111 17.661V26.1549H84.1496V17.7783C84.1496 17.0579 83.5297 16.4715 82.7422 16.4715H81.6866V26.1549H79.5084V5.28043H81.6866V14.3439H82.0887C82.4908 14.3271 82.8092 14.0758 82.8594 13.7575L84.1161 5.28043H86.3446Z",
    fill: "currentColor"
  }
));

export { AnnSacksLogo };
